class ProductCarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = $(this);
    this.slider.slick({
      autoplay: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      vertical: false,

      //cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
      touchThreshold: 100,

      dots: false,
      infinite: false,
      adaptiveHeight: false,
      autoplay: false,
      //draggable: true,
      pauseOnHover: false,
      vertical: false,
      focusOnSelect: false,
      pauseOnFocus: true,
      accessibility: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: 'product-thumbnail-component',
    });
  }

}

customElements.define('product-carousel-component', ProductCarouselComponent);
